import styled from 'styled-components/macro'
import { Subheading, Paragraph } from 'GlobalStyles';

export const AboutHeading = styled(Subheading)`
    color: var(--color-white);
`

export const AboutSubheading = styled(Subheading)`
    color: var(--color-white);
    font-size: 1.3rem;
`

export const AboutParagraph = styled(Paragraph)`
    color: var(--color-white);
    padding-bottom: 1rem;
    text-align: justify;
    
    @media (min-width: 1400px) {
        font-size: 1rem;
        line-height: 1.4rem;
    }
`

export const Link = styled.a`
    color: var(--color-white);
`
